/**
 * O export default de "redux-persist/lib/storage" não resolve corretamente pelo interop
 * CJS/ESM do Vite 8, então usamos um adapter simples sobre localStorage no lugar dele.
 * Cai para um storage no-op quando localStorage está indisponível (SSR, navegação privada,
 * storage desabilitado) para que a persistência falhe silenciosamente em vez de quebrar o app.
 */
interface PersistStorage {
  getItem: (key: string) => Promise<string | null>
  removeItem: (key: string) => Promise<void>
  setItem: (key: string, value: string) => Promise<void>
}

const noopStorage: PersistStorage = {
  getItem: () => Promise.resolve(null),
  removeItem: () => Promise.resolve(),
  setItem: () => Promise.resolve(),
}

function createLocalStorageAdapter(): PersistStorage {
  if (typeof window === 'undefined') return noopStorage

  try {
    const testKey = '__redux_persist_test__'
    window.localStorage.setItem(testKey, testKey)
    window.localStorage.removeItem(testKey)
  } catch {
    return noopStorage
  }

  return {
    getItem: key => Promise.resolve(window.localStorage.getItem(key)),
    removeItem: key => Promise.resolve(window.localStorage.removeItem(key)),
    setItem: (key, value) => {
      try {
        window.localStorage.setItem(key, value)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
  }
}

export default createLocalStorageAdapter()
